import { setJobReferenceValueToFormField } from './jobs';

export default {
  init() {
    setJobReferenceValueToFormField();
  },
};
